import { ManageTeamsCtrl, TeamFormCtrl, TeamsCtrl, TeamService, OrganizationChartCtrl } from ".";
import { OrgChartV3Component } from "./components/org-chart-v3/org-chart-v3.component";

const teamsCoreMod = angular
  .module("teamsCore", [])
  .service("TeamService", TeamService)
  .component("orgChartV3", OrgChartV3Component)
  .controller("TeamsCtrl", TeamsCtrl)
  .controller("OrganizationChartCtrl", OrganizationChartCtrl)
  .controller("ManageTeamsCtrl", ManageTeamsCtrl)
  .controller("TeamFormCtrl", TeamFormCtrl);
export default teamsCoreMod.name;
